import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import type { WebAppLoginResponse } from './autoLogin.api';
import type { MFA_TYPES } from '@Types/types';

export interface ResendLoginMfaPayload {
  customerId: string;
  mfaType: MFA_TYPES;
  remmberMe: boolean;
  loginResponseCustomData: Record<string, unknown>;
  mfaDestination: string;
}

export const resendLoginMfa = async (payload: ResendLoginMfaPayload) => {
  const { customerId } = useBoundStore.getState().customer;
  const url = `v1/user/openauth/${customerId}/login/mfa/resend`;

  const { data } = await HttpService.post<WebAppLoginResponse>(url, {
    clientId: import.meta.env.VITE_CLIENT_ID,
    customData: payload.loginResponseCustomData,
    mfaType: payload.mfaType,
    rememberMe: payload.remmberMe,
    // fingerPrint: (window as unknown as { fpId: string }).fpId,
  });
  return data;
};
